<template>
  <div>
    <Slider :options="options" v-if="brands.length !== 0">
      <div v-for="brand in brands" :key="brand._id">
        <img
          class="brands mx-2"
          :src="
            `https://ardunic-images.s3.eu-central-1.amazonaws.com/${
              brand.image
            }`
          "
          :alt="`${brand.title} Brand Image`"
        />
      </div>
    </Slider>
  </div>
</template>

<script>
import axios from "axios";
import Slider from "./Utilities/Share/Slider";
export default {
  components: {
    Slider,
    // Slide
  },
  data() {
    return {
      brands: [],
      options: {
        autoplay: true,
        autoplaySpeed: 3000,
        timing: "linear",
        centerMode: false,
        slidesToShow: 4,
        loop: true,
        dots: false,
        responsive: [
          {
            breakpoint: 300,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 4,
            },
          },
        ],
      },
    };
  },
  created() {
    this.getSBrands();
  },
  methods: {
    getSBrands() {
      axios.get("https://api.ardunic.com/v1/brands").then((res) => {
        this.brands = res.data.data;
      });
    },
  },
};
</script>

<style scoped>
.VueCarousel-pagination {
  display: none;
}
.brands-container {
  align-items: center;
  border: none;
}

.brands {
  width: 200px;
  height: 200px;
  object-fit: contain;
  object-position: center;
}

@media screen and (max-width: 600px) {
  .brands {
    width: 100%;
    padding: 0px 20px;
  }
}
</style>
